module.exports = __webpack_public_path__ + "static/media/33.6228d197.gif";